export default {
  activity: {
    activityUserSettings: {
      get: "/api/webclient/Activity/GetActivityUserSettings",
      update: "/api/webclient/Activity/UpdateActivityUserSettings"
    },
    create: "/api/webclient/Activity/Create",
    delete: "/api/webclient/Activity/Delete"
  },
  aiDesigner: {
    createSetImages: "/api/webclient/ArtificialIntelligence/CreateSetImages",
    getMediaAssetPathsByReferenceAndMediaAssetId: "/api/webclient/Article/GetMediaAssetPathsByReferenceAndMediaAssetId",
    getSetImageThumbnail: "/api/webclient/ArtificialIntelligence/GetSetImageThumbnail",
    saveSetImage: "/api/webclient/ArtificialIntelligence/SaveSetImage"
  },
  aiParser: {
    getAttributesFromText: "/api/webclient/ArtificialIntelligence/GetAttributesFromText",
    getAttributesFromFile: "/api/webclient/ArtificialIntelligence/GetAttributesFromFile",
    getAttributesFromMediaAsset: "/api/webclient/ArtificialIntelligence/GetAttributesFromMediaAsset"
  },
  aiTexter: {
    getStyles: "/api/webclient/ArtificialIntelligence/GetTextGeneratorStyles",
    generateText: "/api/webclient/ArtificialIntelligence/GenerateText"
  },
  alternativeArticleNumberTypes: {
    get: "/api/webclient/AlternativeArticleNoTypes/GetAlternateAricleNoTypes",
    update: "/api/webclient/AlternativeArticleNoTypes/Update",
    delete: "/api/webclient/AlternativeArticleNoTypes/Delete"
  },
  articleStates: {
    get: "/api/webclient/ArticleStates/Get",
    update: "/api/webclient/ArticleStates/Update",
    delete: "/api/webclient/ArticleStates/Delete"
  },
  article: {
    create: "/api/webclient/Article/Create",
    delete: "/api/webclient/Articles/Delete",
    rename: "/api/webclient/Article/Rename",
    paste: "/api/webclient/Articles/Paste",
    pasteToAnotherCatalog: "/api/webclient/Articles/PasteToAnotherCatalog",
    inherit: "/api/webclient/Article/Inherit",
    deletedArticles: "/api/webclient/Articles/GetDeletedArticles",
    restoreArticles: "/api/webclient/Articles/Restore",
    deletePermanently: "/api/webclient/Articles/DeletePermanently",
    hasAttributeGroupConflict: "/api/webclient/Articles/HasAttributeGroupConflict",
    validationStatus: "/api/webclient/Article/GetAttributeValidationStatus",
    masterData: {
      get: "/api/webclient/Article/GetMasterData",
      update: "/api/webclient/Article/UpdateMasterData"
    },
    articleNumberTypes: {
      get: "/api/webclient/Article/GetArticleNumberTypes"
    },
    globalAttributes: {
      get: "/api/webclient/Article/GetGlobalAttributes",
      update: "/api/webclient/Article/UpdateGlobalAttributes",
      defaultValueListSync: "/api/webclient/Article/ExecuteGlobalAttributesDefaultValueListSync"
    },
    allstates: {
      get: "/api/webclient/commondata/GetAllStatuses"
    },
    alternativeArticleNumbers: {
      get: "/api/webclient/Article/GetAlternateArticles",
      update: "/api/webclient/Article/UpdateAlternativeArticleNos"
    },
    articleHierarchy: {
      get: "/api/webclient/Article/GetArticleHierarchy"
    },
    attributeGroups: {
      get: "/api/webclient/commondata/GetAttributeGroups"
    },
    classifications: {
      get: "/api/webclient/Article/GetClassifications",
      update: "/api/webclient/Article/UpdateClassifications"
    },
    erpSections: {
      get: "/api/webclient/Article/GetErpAttributes",
      update: "/api/webclient/Article/UpdateErpAttributes",
      defaultValueListSync: "/api/webclient/Article/ExecuteErpAttributesDefaultValueListSync"
    },
    variantAttributes: {
      get: "/api/webclient/Article/GetVariantAttributes",
      update: "/api/webclient/Article/UpdateVariantAttributes"
    },
    invariantAttributes: {
      get: "/api/webclient/Article/GetInvariantAttributes",
      update: "/api/webclient/Article/UpdateInvariantAttributes"
    },
    keywords: {
      get: "/api/webclient/Article/GetKeywords",
      update: "/api/webclient/Article/UpdateKeywords"
    },
    mediaAssets: {
      get: "/api/webclient/Article/GetMediaAssets",
      update: "/api/webclient/Article/UpdateMediaAssets"
    },
    multiArticleVariantAttributes: {
      get: "/api/webclient/Article/GetVariantAttributesMultiArticle",
      update: "/api/webclient/Article/UpdateVariantAttributeMultiArticle",
      validationStatus: "/api/webclient/Article/GetVariantAttributesMultiArticleValidationStatus"
    },
    prices: {
      get: "/api/webclient/Article/GetPrices",
      update: "/api/webclient/Article/UpdatePrices"
    },
    priceAttributes: {
      get: "/api/webclient/Article/GetPriceAttributes",
      update: "/api/webclient/Article/UpdatePriceAttributes"
    },
    references: {
      create: "/api/webclient/Article/CreateArticleReference",
      delete: "/api/webclient/Article/DeleteArticleReferences",
      get: "/api/webclient/Article/GetReferences",
      update: "/api/webclient/Article/UpdateReferenceAttributes",
      createCrossReferences: "/api/webclient/Article/CreateCrossReferences",
      exchangeCrossReferences: "/api/webclient/Article/ExchangeCrossReferences"
    },
    catalogs: {
      get: "/api/webclient/Article/GetArticleCatalogs"
    },
    getArticleStateAndVariationGroup: "/api/webclient/Article/GetArticleStateAndVariationGroup",
    defaultValueListSync: "/api/webclient/Article/ExecuteAttributesDefaultValueListSync"
  },
  catalogs: {
    baseCatalog: {
      get: "/api/webclient/CommonData/GetBaseCatalog",
      childCount: "/api/webclient/CatalogNodes/GetCatalogChildCount"
    },
    catalog: {
      get: "/api/webclient/Catalog/GetCatalogs",
      getNames: "/api/webclient/Catalog/GetCatalogNames",
      create: "api/webclient/Catalog/Create",
      delete: "/api/webclient/Catalog/Delete",
      deleteMultiple: "/api/webclient/Catalog/DeleteMultiple",
      rename: "/api/webclient/Catalog/Rename",
      settings: "/api/webclient/Catalog/GetCatalogSettings",
      updateSettings: "/api/webclient/Catalog/UpdateCatalogSettings",
      checkLinkedNodesExists: "/api/webclient/Catalog/IsCatalogLinked",
      copy: "/api/webclient/Catalog/Copy",
      downloadEcfArticles: "/api/webclient/Catalog/DownloadNonExistingArticlesFromExternalFile",
      generateFromExternalData: "/api/webclient/Catalog/GenerateCatalogFromExternalData",
      generateFromFile: "/api/webclient/Catalog/GenerateCatalog",
      downloadNonExistingArticles: "/api/webclient/Catalog/DownloadNonExistingArticlesInCatalog",
      generateFromFilter: "/api/webclient/Catalog/GenerateCatalogFromFilter"
    },
    categoris: {
      get: "api/webclient/Catalog/GetCatalogCategories"
    },
    catalogAttributes: {
      get: "api/webclient/Catalog/GetCatalogAttributes",
      update: "api/webclient/Catalog/UpdateCatalogAttributes"
    },
    mappingTargets: {
      get: "api/webclient/Catalog/GetCatalogMappingTargets"
    },
    mappingProjects: {
      get: "api/webclient/Catalog/GetCatalogMappingProjects",
      create: "api/webclient/Catalog/CreateCatalogMappingProject",
      rename: "api/webclient/Catalog/renameMappingProject",
      delete: "api/webclient/Catalog/DeleteMappingProject",
      copy: "api/webclient/Catalog/CopyMappingProject"
    },
    allMappingProjects: {
      get: "api/webclient/Catalog/GetAllCatalogMappingProjects"
    },
    catalogMappingSourceFieldLocalizations: {
      get: "api/webclient/Catalog/getCatalogMappingSourceFieldLocalizations"
    },
    targetMappingNodes: {
      get: "api/webclient/Catalog/getMappingTargetNodes"
    },
    rootNodes: {
      get: "/api/webclient/CatalogNodes/GetRootCatalogNodes"
    },
    nodes: {
      get: "/api/webclient/CatalogNodes/GetCatalogNodes",
      move: "/api/webclient/CatalogNode/MovePosition",
      create: "/api/webclient/CatalogNode/Create",
      moveTo: "/api/webclient/CatalogNode/MoveTo",
      delete: "/api/webclient/CatalogNode/Delete",
      sort: "/api/webclient/CatalogNode/Sort",
      rename: "/api/webclient/CatalogNode/Rename",
      paste: "/api/webclient/CatalogNode/Paste",
      childCount: "/api/webclient/CatalogNodes/GetCatalogNodeChildCount",
      pasteToAnothercatalog: "/api/webclient/CatalogNode/PasteToAnotherCatalog",
      resolveLinkedCatalogNode: "/api/webclient/CatalogNode/ResolveLinkedCatalogNode"
    },
    articles: {
      existInBaseCatalog: "api/webclient/Catalog/CheckArticleInBaseCatalog"
    },
    snapshot: {
      get: "/api/webclient/Catalog/GetCatalogSnapshotHistory",
      multiple: "/api/webclient/Catalog/GetCatalogSnapshotHistoryMultiple",
      create: "/api/webclient/Catalog/TakeCatalogSnapshot",
      restore: "/api/webclient/Catalog/RestoreCatalogSnapshot",
      copy: "/api/webclient/Catalog/CopyCatalogSnapShot",
      delete: "/api/webclient/Catalog/DeleteCatalogSnapshot"
    }
  },
  variationGroups: {
    articles: {
      get: "/api/webclient/CatalogNode/GetArticlesUnderVariationGroup",
      move: "/api/webclient/Articles/MovePosition",
      moveTo: "/api/webclient/Article/MoveTo"
    },
    deleteEmpty: "/api/webclient/CatalogNodes/DeleteEmptyVariationGroups",
    mediaAssets: {
      get: "/api/webclient/CatalogNode/GetMediaAssetsUnderVariationGroup",
      update: "/api/webclient/CatalogNode/UpdateMediaAssetsUnderVariationGroup"
    },
    prices: {
      get: "/api/webclient/CatalogNode/GetPricesUnderVariationgroup",
      update: "/api/webclient/CatalogNode/UpdateArticlePricesUnderVariationgroup"
    },
    priceAttributes: {
      get: "/api/webclient/CatalogNode/GetPriceAttributesFromArticleUnderVariationGroup"
    },
    attributes: {
      get: "/api/webclient/CatalogNode/GetVariantAttributesAndPricesUnderVariationGroup"
    }
  },
  attributePath: {
    get: "/api/webclient/AttributeGroups/GetPath"
  },
  languages: {
    get: "/api/Language/GetLanguages",
    update: "/api/Language/Update",
    delete: "/api/Language/Delete",
    translationStatus: {
      get: "/api/Language/GetIsTranslationStatusEnabled",
      update: "/api/Language/UpdateIsTranslationStatusEnabled"
    },
    getAvailableLanguageCodes: "/api/Language/GetAvailableLanguageCodes"
  },
  languageRegions: {
    get: "api/webclient/commondata/GetLanguageRegions"
  },
  localizedLanguages: {
    get: "api/webclient/commondata/GetLanguagesWithLocalizedName"
  },
  user: {
    settings: {
      get: "api/webclient/UserSettings/GetSettings",
      post: "api/webclient/UserSettings/UpdateSettings"
    },
    profile: {
      get: "/api/webclient/User/GetProfile",
      getProfileImage: "/api/webclient/User/GetUserProfileImage",
      changePassword: "/api/webclient/User/ChangePassword"
    },
    list: {
      get: "/api/webclient/User/GetAllUsers",
      details: "/api/webclient/User/GetAllUsersDetails",
      createUsers: "/api/webclient/User/CreateUser",
      updateUsers: "/api/webclient/User/UpdateUser",
      deleteUsers: "/api/webclient/User/DeleteUser"
    },
    licenses: {
      get: "/api/Account/Licenses"
    }
  },
  roles: {
    get: "/api/webclient/Roles/Get",
    update: "/api/webclient/Roles/Update",
    delete: "/api/webclient/Roles/Delete"
  },
  permissions: {
    get: "/api/webclient/RolePermissions/Get",
    getCatalogNodePermissions: "/api/webclient/RolePermissions/GetCatalogNodePermissions",
    update: "/api/webclient/RolePermissions/Update"
  },
  userLicenses: {
    get: "/api/webclient/UserLicense/Get",
    assign: "/api/webclient/UserLicense/Assign",
    unassign: "/api/webclient/UserLicense/Unassign"
  },
  erp: {
    profiles: "api/webclient/commondata/GetErpProfiles",
    parameters: "api/webclient/commondata/GetErpParameters"
  },
  globalParameters: {
    get: "api/webclient/GlobalParameters/GetGlobalParameters",
    update: "api/webclient/GlobalParameters/UpdateGlobalParameters"
  },
  catalogNodes: {
    masterData: {
      get: "/api/webclient/CatalogNode/CatalogNodeDetails",
      update: "/api/webclient/CatalogNode/UpdateMasterData"
    },
    path: {
      getFromBaseCatalog: "/api/webclient/CatalogNode/GetCatalogNodePathInBaseCatalog",
      get: "/api/webclient/CatalogNode/GetCatalogNodePath"
    },
    mediaAssets: {
      get: "/api/webclient/CatalogNode/CatalogNodeMediaAssets",
      update: "/api/webclient/CatalogNode/UpdateMediaAssets"
    },
    attributes: {
      get: "/api/webclient/CatalogNode/CatalogNodeAttributes",
      update: "/api/webclient/CatalogNode/UpdateAttributeData"
    },
    status: {
      get: "/api/webclient/CatalogNodes/GetStatusOfCatalogNodes"
    },
    deleteEmpty: "/api/webclient/CatalogNodes/DeleteEmptyCatalogGroups",
    newChildOptions: "/api/webclient/CatalogNodes/GetNewChildOptions"
  },
  excelEdit: {
    export: "/api/webclient/ExcelEdit/ExportToExcel",
    download: "/api/webclient/ExcelEdit/download",
    import: "/api/webclient/ExcelEdit/ExcelImport",
    GetExportDataTypes: "/api/webclient/ExcelEdit/GetExportDataTypes",
    GetMamParameterTypes: "/api/webclient/ExcelEdit/GetMamParameterTypes",
    GetAttributeGroupsOfCatalogNode: "/api/webclient/ExcelEdit/GetAttributeGroupsOfCatalogNode",
    GetAttributeGroupsOfAdvancedSearch: "/api/webclient/ExcelEdit/GetAttributeGroupsOfAdvancedSearch",
    exportAdvancedSearch: "/api/webclient/ExcelEdit/ExportFromAdvancedSearch"
  },
  simpleSearch: {
    get: "/api/webclient/EasySearch/SearchArticlePaged",
    catalog: "/api/webclient/EasySearch/SearchInCatalog"
  },
  attributeGroupSearch: {
    get: "/api/webclient/AttributeGroups/Search"
  },
  classifications: {
    search: {
      get: "/api/webclient/Classifications/Search"
    },
    getClassificationPath: {
      get: "/api/webclient/Classifications/GetClassificationPath"
    },
    classificationGroups: {
      get: "/api/webclient/Classifications/GetClassificationGroups"
    },
    classificationDetails: {
      get: "/api/webclient/Classifications/GetClassificationDetails"
    }
  },
  referenceTypes: {
    get: "/api/webclient/ReferenceType/GetReferenceTypes"
  },
  keywordTypes: {
    get: "/api/webclient/KeywordTypes/Get",
    update: "/api/webclient/KeywordTypes/Update",
    delete: "/api/webclient/KeywordTypes/Delete",
    deepL: "/api/webclient/KeywordTypes/SaveDeepLTranslatedValues"
  },
  smartSnippets: {
    get: "/api/webclient/SmartSnippet/GetSmartSnippets",
    resolved: {
      get: "/api/webclient/SmartSnippet/GetResolvedSmartSnippet"
    }
  },
  suggests: {
    globalAttributeValue: {
      get: "/api/webclient/Suggest/GetGlobalAttributeValues"
    },
    globalAttributeValueUid: {
      get: "/api/webclient/Suggest/GetGlobalAttributeValueUids"
    },
    globalAttributeValueAbbreviation: {
      get: "/api/webclient/Suggest/GetGlobalAttributeValueAbbreviations"
    },
    globalAttributeUnit: {
      get: "/api/webclient/Suggest/GetGlobalAttributeUnits"
    },
    globalAttributeUnitUid: {
      get: "/api/webclient/Suggest/GetGlobalAttributeUnitUids"
    },
    globalAttributeUnitAbbreviation: {
      get: "/api/webclient/Suggest/GetGlobalAttributeUnitAbbreviations"
    },
    attributeValue: {
      get: "/api/webclient/Suggest/GetAttributeValues"
    },
    attributeValueUid: {
      get: "/api/webclient/Suggest/GetAttributeValueUids"
    },
    attributeValueAbbreviation: {
      get: "/api/webclient/Suggest/GetAttributeValueAbbreviations"
    },
    attributeUnit: {
      get: "/api/webclient/Suggest/GetAttributeUnits"
    },
    attributeUnitUid: {
      get: "/api/webclient/Suggest/GetAttributeUnitUids"
    },
    attributeUnitAbbreviation: {
      get: "/api/webclient/Suggest/GetAttributeUnitAbbreviations"
    },
    erpAttributeValue: {
      get: "/api/webclient/Suggest/GetErpAttributeValues"
    },
    erpAttributeValueUid: {
      get: "/api/webclient/Suggest/GetErpAttributeValueUids"
    },
    erpAttributeValueAbbreviation: {
      get: "/api/webclient/Suggest/GetErpAttributeValueAbbreviations"
    },
    erpAttributeUnit: {
      get: "/api/webclient/Suggest/GetErpAttributeUnits"
    },
    erpAttributeUnitUid: {
      get: "/api/webclient/Suggest/GetErpAttributeUnitUids"
    },
    erpAttributeUnitAbbreviation: {
      get: "/api/webclient/Suggest/GetErpAttributeUnitAbbreviations"
    }
  },
  articleTranslations: {
    globalAttributeValues: {
      get: "/api/webclient/TranslationArticles/GetGlobalAttributeValues",
      update: "/api/webclient/TranslationArticles/UpdateGlobalAttributes"
    },
    invariantAttributeValues: {
      get: "/api/webclient/TranslationArticles/GetInvariantAttributeValues",
      update: "/api/webclient/TranslationArticles/UpdateInvariantAttributes"
    },
    keywords: {
      get: "/api/webclient/TranslationArticles/GetKeywords",
      update: "/api/webclient/TranslationArticles/UpdateKeywords"
    },
    masterData: {
      get: "/api/webclient/TranslationArticles/GetMasterData",
      update: "/api/webclient/TranslationArticles/UpdateMasterdata"
    },
    mediaAssets: {
      get: "/api/webclient/TranslationArticles/GetMediaAssetValues",
      update: "/api/webclient/TranslationArticles/UpdateMediaAssets"
    },
    priceAttributeValues: {
      get: "/api/webclient/TranslationArticles/GetPriceAttributeValues",
      update: "/api/webclient/TranslationArticles/UpdatePriceAttributes"
    },
    saveTranslateAllByDeepL: {
      update: "/api/webclient/TranslationArticles/SaveAllDeepLTranslatedArticleData"
    },
    saveTranslateAllFromMemory: {
      update: "/api/webclient/TranslationArticles/SaveAllTranslatedArticleDataFromTranslationMemory"
    },
    suggestions: {
      globalAttributes: {
        get: "/api/webclient/TranslationArticles/GetSuggestionsForGlobalAttributes"
      },
      invariantAttributeValues: {
        get: "/api/webclient/TranslationArticles/GetSuggestionsForInvariantAttributes"
      },
      keywords: {
        get: "/api/webclient/TranslationArticles/GetSuggestionsForKeywords"
      },
      mediaAssets: {
        get: "/api/webclient/TranslationArticles/GetSuggestionsForMediaAssets"
      },
      priceAttributeValues: {
        get: "/api/webclient/TranslationArticles/GetSuggestionsForPriceAttributes"
      },
      variantAttributeValues: {
        get: "/api/webclient/TranslationArticles/GetSuggestionsForVariantAttributes"
      }
    },
    translateAllGlobalAttributes: {
      get: "/api/webclient/TranslationArticles/GetAllGlobalAttributeTranslateValues"
    },
    translateAllInvariantAttributes: {
      get: "/api/webclient/TranslationArticles/GetAllInvariantAttributeTranslateValues"
    },
    translateAllKeywords: {
      get: "/api/webclient/TranslationArticles/GetAllKeywordTranslateValues"
    },
    translateAllMediaAssets: {
      get: "/api/webclient/TranslationArticles/GetAllMediaAssetTranslatedValues"
    },
    translateAllPriceAttributes: {
      get: "/api/webclient/TranslationArticles/GetAllPriceAttributeTranslateValues"
    },
    translateAllVariantAttributes: {
      get: "/api/webclient/TranslationArticles/GetAllVariantAttributeTranslateValues"
    },
    variantAttributeValues: {
      get: "/api/webclient/TranslationArticles/GetVariantAttributeValues",
      update: "/api/webclient/TranslationArticles/UpdateVariantAttributes"
    }
  },
  attributeManager: {
    attributes: {
      get: "/api/webclient/Attributes/GetAttributes",
      update: "/api/webclient/Attributes/UpdateAttributes",
      delete: "/api/webclient/Attributes/Delete",
      getDescendantAttributes: "/api/webclient/Attributes/GetDescendantAttributeGroupsAttributes",
      details: "/api/webclient/Attributes/GetAttributeDetails",
      values: {
        get: "/api/webclient/Attributes/GetDefaultAttributeValues",
        update: "/api/webclient/Attributes/UpdateDefaultAttributeValues",
        delete: "/api/webclient/Attributes/DeleteDefaultAttributeValues"
      },
      units: {
        get: "/api/webclient/Attributes/GetDefaultAttributeUnits",
        update: "/api/webclient/Attributes/UpdateDefaultAttributeUnits",
        delete: "/api/webclient/Attributes/DeleteDefaultAttributeUnits"
      },
      deepL: "/api/webclient/Attributes/SaveDeepLTranslatedValues"
    },
    priceAttributes: {
      get: "/api/webclient/PriceAttribute/Get",
      update: "/api/webclient/PriceAttribute/Update"
    },
    attributeTypes: {
      get: "/api/webclient/AttributeTypes/Get",
      update: "/api/webclient/AttributeTypes/Update",
      delete: "/api/webclient/AttributeTypes/Delete",
      deepL: "/api/webclient/AttributeTypes/SaveDeepLTranslatedValues"
    },
    globalAttributes: {
      get: "/api/webclient/GlobalAttributes/Get",
      update: "/api/webclient/GlobalAttributes/Update",
      delete: "/api/webclient/GlobalAttributes/Delete",
      values: {
        get: "/api/webclient/GlobalAttributes/GetDefaultAttributeValues",
        update: "/api/webclient/GlobalAttributes/UpdateDefaultAttributeValues",
        delete: "/api/webclient/GlobalAttributes/DeleteDefaultAttributeValues"
      },
      units: {
        get: "/api/webclient/GlobalAttributes/GetDefaultAttributeUnits",
        update: "/api/webclient/GlobalAttributes/UpdateDefaultAttributeUnits",
        delete: "/api/webclient/GlobalAttributes/DeleteDefaultAttributeUnits"
      },
      deepL: "/api/webclient/GlobalAttributes/SaveDeepLTranslatedValues",
      details: "/api/webclient/GlobalAttributes/GetGlobalAttributeDetails"
    },
    mediaAssets: {
      get: "/api/webclient/MediaAssets/Get",
      update: "/api/webclient/MediaAssets/Update",
      delete: "/api/webclient/MediaAssets/Delete",
      details: "/api/webclient/MediaAssets/GetMediaAssetDetails",
      getConversionProfiles: "/api/webclient/MediaAssets/GetConversionProfiles",
      getMamDetails: "/api/webclient/MediaAssets/GetMamDetails",
      getPreviewMediaAsset: "/api/webclient/MediaAssets/GetPreviewMediaAsset",
      setPreviewMediaAsset: "/api/webclient/MediaAssets/SetPreviewMediaAsset",
      deepL: "/api/webclient/MediaAssets/SaveDeepLTranslatedValues"
    },
    attributeDataTypes: {
      get: "/api/webclient/Attributes/GetAttributeDataTypes"
    },
    mediaAssetTypes: {
      get: "/api/webclient/MediaAssetTypes/Get",
      update: "/api/webclient/MediaAssetTypes/Update",
      delete: "/api/webclient/MediaAssetTypes/Delete",
      validateInitialRelativePath: "/api/webclient/MediaAssetTypes/ValidateInitialRelativePath",
      deepL: "/api/webclient/MediaAssetTypes/SaveDeepLTranslatedValues"
    },
    catalogAttributes: {
      get: "/api/webclient/CatalogAttributes/Get",
      update: "/api/webclient/CatalogAttributes/Update",
      delete: "/api/webclient/CatalogAttributes/Delete",
      deepL: "/api/webclient/CatalogAttributes/SaveDeepLTranslatedValues"
    },
    catalogGroupAttributes: {
      get: "/api/webclient/CatalogNodeAttributes/Get",
      update: "/api/webclient/CatalogNodeAttributes/Update",
      delete: "/api/webclient/CatalogNodeAttributes/Delete",
      deepL: "/api/webclient/CatalogNodeAttributes/SaveDeepLTranslatedValues"
    },
    referenceTypes: {
      get: "/api/webclient/References/GetReferenceTypes",
      update: "/api/webclient/References/UpdateReferenceTypes",
      delete: "/api/webclient/References/DeleteReferenceTypes",
      deepL: "/api/webclient/References/SaveDeepLTranslatedReferenceAttributeTypes"
    },
    referenceAttributes: {
      get: "/api/webclient/References/GetReferenceAttributes",
      update: "/api/webclient/References/UpdateReferenceAttributes",
      delete: "/api/webclient/References/DeleteReferenceAttributes",
      deepL: "/api/webclient/References/SaveDeepLTranslatedReferenceAttributes"
    },
    erpSections: {
      get: "/api/webclient/ErpSections/Get",
      update: "/api/webclient/ErpSections/Update",
      delete: "/api/webclient/ErpSections/Delete"
    },
    erpAttributes: {
      get: "/api/webclient/ErpAttributes/Get",
      update: "/api/webclient/ErpAttributes/Update",
      delete: "/api/webclient/ErpAttributes/Delete",
      values: {
        get: "/api/webclient/ErpAttributes/GetDefaultErpAttributeValues",
        update: "/api/webclient/ErpAttributes/UpdateDefaultErpAttributeValues",
        delete: "/api/webclient/ErpAttributes/DeleteDefaultErpAttributeValues"
      },
      units: {
        get: "/api/webclient/ErpAttributes/GetDefaultErpAttributeUnits",
        update: "/api/webclient/ErpAttributes/UpdateDefaultErpAttributeUnits",
        delete: "/api/webclient/ErpAttributes/DeleteDefaultErpAttributeUnits"
      },
      deepL: "/api/webclient/ErpAttributes/SaveDeepLTranslatedValues",
      details: "/api/webclient/ErpAttributes/GetErpAttributeDetails"
    },
    localizedBooleanValues: {
      get: "/api/webclient/commondata/GetLocalizedbooleanValues"
    }
  },
  authentication: {
    login: "/api/Account/Authenticate",
    loginWithCode: "/api/Account/AuthenticateWithCode",
    logout: "/api/Account/Logout",
    generateJwt: "/api/Account/GenerateJwt"
  },
  catalogFilter: {
    addUserCatalogFilter: "/api/webclient/CatalogFilter/AddUserCatalogFilter",
    deleteUsercatalogFilter: "/api/webclient/CatalogFilter/DeleteUsercatalogFilter",
    getAllUserCatalogFilterCategories: "/api/webclient/CatalogFilter/GetAllUserCatalogFilterCategories",
    getCatalogFilterList: "/api/webclient/CatalogFilter/GetCatalogFilterList",
    catalogFilterResultsCount: "/api/webclient/CatalogFilter/CatalogFilterResultsCount",
    getUserCatalogFilters: "/api/webclient/CatalogFilter/GetUserCatalogFilters"
  },
  catalogNodeTranslation: {
    attributes: {
      get: "/api/webclient/TranslationCatalogNode/GetAttributeValues",
      update: "/api/webclient/TranslationCatalogNode/UpdateAttributeData"
    },
    masterData: {
      get: "/api/webclient/TranslationCatalogNode/GetMasterData",
      update: "/api/webclient/TranslationCatalogNode/UpdateMasterData"
    },
    mediaAsset: {
      get: "/api/webclient/TranslationCatalogNode/GetMediaAssetValues",
      update: "/api/webclient/TranslationCatalogNode/UpdateMediaAsset"
    },
    suggestions: {
      catalogAttributes: {
        get: "/api/webclient/TranslationCatalogNode/GetSuggestionsForCatalogGroupAttributes"
      },
      catalogDescription: {
        get: "/api/webclient/TranslationCatalogNode/GetSuggestionsForCatalogGroupDescription"
      },
      catalogGroupName: {
        get: "/api/webclient/TranslationCatalogNode/GetSuggestionsForCatalogGroupName"
      },
      catalogMediaAssets: {
        get: "/api/webclient/TranslationCatalogNode/GetSuggestionsForCatalogGroupMediaAssets"
      }
    },
    translateAllAttributes: {
      get: "/api/webclient/TranslationCatalogNode/GetAllAttributeTranslateValues"
    },
    translateAllMasterdata: {
      get: "/api/webclient/TranslationCatalogNode/GetAllMasterdataTranslateValues"
    },
    translateAllMediaAssets: {
      get: "/api/webclient/TranslationCatalogNode/GetAllTranslatedCatalogMediaAssets"
    }
  },
  dashboard: {
    activities: "api/webclient/Dashboard/GetActivities",
    articelPerCatalogGroup: "api/webclient/Dashboard/GetArticlesCountInCatalogGroups",
    articlesCountByCreatedDate: "/api/webclient/Dashboard/GetArticlesCountByCreatedDate",
    overview: "/api/webclient/Dashboard/GetOverView",
    recentlyModifiedArticles: "api/webclient/Dashboard/GetRecentlyModifiedArticles"
  },
  deepLTranslation: {
    get: "/api/webclient/DeepLTranslation/TranslationProxy",
    glossary: {
      getGlossaries: "/api/webclient/DeepLTranslation/GetGlossaries",
      getGlossaryEntries: "/api/webclient/DeepLTranslation/GetGlossaryEntries",
      deleteGlossaries: "/api/webclient/DeepLTranslation/DeleteGlossaries",
      deleteGlossary: "/api/webclient/DeepLTranslation/DeleteGlossary",
      updateGlossary: "/api/webclient/DeepLTranslation/UpdateGlossary",
      getGlossaryLanguagePairs: "/api/webclient/DeepLTranslation/GetGlossaryLanguagePairs",
      exportGlossaryEntriesToFile: "/api/webclient/DeepLTranslation/ExportGlossaryEntriesToFile",
      importGlossaryEntriesFromFile: "/api/webclient/DeepLTranslation/ImportGlossaryEntriesFromFile"
    }
  },
  encodings: {
    get: "/api/webclient/commondata/GetEncodings"
  },
  externalData: {
    getAllExternalDataConnectionNames: "/api/webclient/ExternalData/GetAllExternalDataConnectionNames",
    getAllSelectionCommandsGrouped: "/api/webclient/ExternalData/GetAllSelectionCommandsGrouped",
    getSingleColumnNameOfSelectionCommand: "/api/webclient/ExternalData/GetSingleColumnNameOfSelectionCommand"
  },
  files: {
    upload: "/api/webclient/FileManager/UploadFile",
    fieldHeaders: {
      post: "/api/webclient/FileManager/GetFieldHeadersFromSourceFile"
    }
  },
  liveEdit: {
    multiImageCatalog: {
      images: {
        get: "/api/webclient/mediaasset/GetMultiImageLayoutMediaAssetData"
      }
    },
    paperCatalog: {
      images: {
        get: "/api/webclient/mediaasset/GetPaperCatalogImageTypes"
      }
    }
  },
  logging: {
    browse: "/api/Log/Browse",
    event: "/api/Log/Event",
    events: "/api/Log/Events",
    export: "/api/Log/Export"
  },
  mapping: {
    catalogFields: {
      create: "/api/webclient/CatalogFieldMapping/Create",
      delete: "/api/webclient/CatalogFieldMapping/Delete",
      deleteAll: "api/webclient/CatalogFieldMapping/DeleteAll",
      get: "api/webclient/CatalogFieldMapping/get",
      move: "/api/webclient/CatalogMapping/MoveTargetNodes",
      rename: "/api/webclient/CatalogMapping/RenameTargetNodes",
      reset: "/api/webclient/CatalogMapping/ResetTargetNodeNames",
      update: "/api/webclient/CatalogFieldMapping/Update"
    },
    catalogMappings: {
      create: "api/webclient/CatalogMapping/Create",
      get: "api/webclient/Catalog/getCatalogMappings"
    },
    sourceTree: {
      fields: {
        get: "/api/webclient/Catalog/GetCatalogMappingSourceTreeFields"
      }
    }
  },
  mediaAssets: {
    copySourceFileIntoTargetPath: "/api/webclient/MediaAsset/copySourceFileIntoTargetPath",
    downloadMediaAsset: "/api/webclient/MediaAsset/downloadMediaAsset",
    files: "/api/webclient/MediaAsset/GetMediaAssetFilesFromFolder",
    preview: "/api/webclient/MediaAsset/GetThumbnail",
    startMediaConversion: "/api/webclient/MediaAsset/startMediaConversion",
    startAllMediaConversion: "/api/webclient/MediaAsset/startAllMediaAssetsConversion",
    subFolders: "/api/webclient/MediaAsset/GetMediaAssetSubfolders",
    uploadMediaAsset: "/api/webclient/MediaAsset/uploadMediaAsset",
    validateFilePath: "/api/webclient/MediaAsset/validateFilePath",
    executeSearch: "/api/webclient/MediaAsset/ExecuteMediaAssetSearch",
    cancelSearch: "/api/webclient/MediaAsset/CancelMediaAssetSearch",
    folder: {
      create: "/api/webclient/MediaAssetFolder/CreateFolder"
    },
    deleteMediaAsset: "/api/webclient/MediaAsset/DeleteFile",
    deleteMediaAssetFolder: "/api/webclient/MediaAssetFolder/DeleteFolder",
    renameMediaAsset: "/api/webclient/MediaAsset/RenameFile",
    renameMediaAssetFolder: "/api/webclient/MediaAssetFolder/RenameFolder"
  },
  attributeGroups: {
    create: "/api/webclient/AttributeGroups/Create",
    delete: "/api/webclient/AttributeGroups/Delete",
    getPath: "/api/webclient/AttributeGroups/GetPath",
    search: "/api/webclient/AttributeGroups/Search",
    rename: "/api/webclient/AttributeGroups/Rename",
    getAttributeGroup: "/api/webclient/AttributeGroups/GetAttributeGroup",
    checkForDuplicates: "/api/webclient/AttributeGroups/CheckForDuplicates",
    sort: "/api/webclient/AttributeGroups/Sort",
    move: "/api/webclient/AttributeGroups/MovePosition",
    translate: "/api/webclient/AttributeGroups/Translate"
  },

  exports: {
    getCatalogs: "/api/webclient/Export/GetCatalogs",
    getCatalogMappingProjects: "/api/webclient/Export/GetCatalogMappingProjects",
    getArticleFilters: "/api/webclient/Export/GetArticleFilters",
    getRuleProfiles: "/api/webclient/Export/GetRuleProfiles",
    getExcelMacros: "/api/webclient/Export/GetExcelMacros",
    startExport: "/api/webclient/Export/Execute",
    getExportSettings: "", //TODO: After API Creation
    getExportProgress: "/api/webclient/Export/GetProgress",
    delete: "/api/webclient/Export/Delete",
    getExports: "/api/webclient/Export/Get",
    create: "/api/webclient/Export/Create",
    update: "/api/webclient/Export/Update",
    cancel: "/api/webclient/Export/Cancel",
    prepareForDownload: "/api/webclient/Export/PrepareForDownload",
    download: "/api/webclient/Export/download",
    getLog: "/api/webclient/Export/GetLog",
    uploadXsltFile: "/api/webclient/Export/UploadXsltFile",
    getLastExport: "/api/webclient/Export/GetLastExport",
    enableLastExport: "/api/webclient/Export/GetLastExportEnabledStatus",
    tradePro: {
      validateFTP: "/api/webclient/Export/ValidateFileUploadConnection",
      validateAndGetTradeProChannels: "/api/webclient/Export/ValidateAndGetTradeProChannels"
    },
    getTranslationTable: "/api/webclient/Export/GetTranslationTable",
    updateTranslationTable: "/api/webclient/Export/UpdateTranslationTable"
  },

  fastpage: {
    designer: {
      getInfo: "/api/webclient/ListLabelItems/Get",
      getItemsFromFolder: "/api/webclient/ListLabelItems/GetFromFolder",
      getUserOrDefaultFolders: "/api/webclient/ListLabelItems/GetUserOrDefaultLayoutChildren",
      create: "/api/webclient/ListLabelItems/Create",
      rename: "/api/webclient/ListLabelItems/Rename",
      paste: "/api/webclient/ListLabelItems/Copy",
      createPreview: "/api/webclient/ListLabelItems/CreatePreview"
    },
    windowsDesigner: {
      start: "/api/webclient/listlabel/ListLabelWebDesigner/Start"
    }
  },

  unitSystems: {
    get: "/api/webclient/UnitSystems/GetUnitSystems"
  },
  userTasks: {
    get: "/api/webclient/UserTasks/GetUserTasks",
    getCurrentMonth: "/api/webclient/UserTasks/GetUserTasksOnCurrentMonth",
    create: "/api/webclient/UserTasks/CreateUserTask",
    createWorkManagerUserTask: "/api/webclient/UserTasks/CreateWorkManagerUserTask",
    delete: "/api/webclient/UserTasks/DeleteUserTasks",
    update: "/api/webclient/UserTasks/UpdateUserTask",
    updateUserTaskDetails: "/api/webclient/UserTasks/UpdateUserTaskDetails",
    getProjects: "/api/webclient/UserTasks/GetProjects",
    getUserTaskDetails: "/api/webclient/UserTasks/GetUserTaskDetails",
    getAttachmentDetails: "/api/webclient/UserTasks/GetAttachmentDetails",
    getTaskObjects: "/api/webclient/UserTasks/GetTaskObjects",
    downloadAttachment: "/api/webclient/UserTasks/DownloadAttachment",
    addAttachment: "/api/webclient/UserTasks/AddAttachment",
    updateAttachment: "/api/webclient/UserTasks/UpdateAttachment",
    updateProjects: "/api/webclient/UserTasks/UpdateProjects",
    deleteProjects: "/api/webclient/UserTasks/DeleteProjects",
    sendMail: "/api/webclient/UserTasks/SendMail",
    updateObjectDetails: "/api/webclient/UserTasks/UpdateObjectDetails",
    createFromAdvancedSearch: "/api/webclient/UserTasks/CreateTaskFromAdvancedSearch"
  },
  thirdparty: {
    get: "/api/ThirdpartyLicence/Get"
  },
  autoMapping: {
    getAdvancedSettings: "/api/webclient/AutoMapping/GetAdvancedAutoMappingSettings",
    saveAdvancedSettings: "/api/webclient/AutoMapping/SaveAdvancedAutoMappingSettings",
    saveAutoMappingProfile: "/api/webclient/AutoMapping/SaveAutoMappingProfile",
    deleteProfile: "/api/webclient/AutoMapping/DeleteProfile",
    getAutoMappingScriptDetails: "/api/webclient/AutoMapping/GetAutoMappingDetails",
    getAutoMappingProfile: "/api/webclient/AutoMapping/GetAutoMappingProfile",
    execute: "/api/webclient/AutoMapping/Execute",
    getMappingScriptNames: "/api/webclient/AutoMapping/GetMappingScriptNames",
    getMappingExpression: "/api/webclient/AutoMapping/GetMappingExpression"
  },
  automationServer: {
    get: "/api/webclient/Automation/Get",
    getAll: "/api/webclient/Automation/GetAll",
    getAllTemplates: "/api/webclient/Automation/GetAllTemplates",
    update: "/api/webclient/Automation/CreateOrUpdate",
    getActionTypes: "/api/webclient/Automation/GetActionTypes",
    delete: "/api/webclient/Automation/DeleteAutomations",
    execute: "/api/webclient/Automation/ExecuteAutomations",
    activateOrDeactivate: "/api/webclient/Automation/ActivateDeactivateAutomations",
    getTriggerTypes: "/api/webclient/Automation/GetTriggerTypes",
    getProjectFiles: "/api/webclient/Automation/GetProjectFiles",
    getPowershellFiles: "/api/webclient/Automation/GetPowershellFiles",
    executeAutomationsIfRequired: "/api/webclient/Automation/ExecuteAutomationsIfRequired",
    getAutomationRun: "/api/webclient/Automation/GetAutomationRun",
    getActionsOnAutomation: "/api/webclient/Automation/GetExecutedAutomationActions"
  },
  advancedSearch: {
    getSearchTypes: "/api/webclient/AdvancedSearch/GetSearchTypes",
    execute: "/api/webclient/AdvancedSearch/Execute",
    save: "/api/webclient/AdvancedSearch/Save",
    canDelete: "/api/webclient/AdvancedSearch/CanDelete",
    delete: "/api/webclient/AdvancedSearch/Delete",
    getAll: "/api/webclient/AdvancedSearch/GetAll",
    get: "/api/webclient/AdvancedSearch/Get",
    exportCsv: "/api/webclient/AdvancedSearch/ExportAsCsv",
    downloadCsv: "/api/webclient/AdvancedSearch/DownloadCsv"
  },
  healthChecks: {
    version: "/HealthTests/GetVersion",
    database: {
      status: "/HealthTests/DatabaseStatus",
      compatibility: "/HealthTests/CheckDatabaseVersionCompatibility",
      scripts: "/HealthTests/CheckWebClientDatabaseScriptIsApplied"
    },
    media: "/HealthTests/CheckMediaDataPathAccess"
  },
  configurationManager: {
    unitSystem: {
      get: "/api/webclient/UnitSystems/GetUnitSystems",
      update: "/api/webclient/UnitSystems/UpdateUnitSystems",
      rename: "/api/webclient/UnitSystems/Rename",
      copy: "/api/webclient/UnitSystems/Copy",
      delete: "/api/webclient/UnitSystems/DeleteUnitsystems"
    },
    unitTranslation: {
      get: "/api/webclient/UnitSystems/GetUnitSystemTranslations",
      update: "/api/webclient/UnitSystems/UpdateUnitTranslations",
      delete: "/api/webclient/UnitSystems/DeleteUnitTranslations"
    },
    emailSettings: {
      get: "/api/webclient/Email/GetEmailConfigurations",
      update: "/api/webclient/Email/UpdateEmailConfigurations",
      oAuth: {
        check: "/api/webclient/Email/CheckOAuthAuthentication",
        delete: "/api/webclient/Email/DeleteOAuthAuthentication",
        start: "/api/webclient/Email/StartOAuthAuthenticate",
        checkResult: "/api/webclient/Email/CheckOAuthAuthenticateResult"
      }
    },
    ruleProfile: {
      get: "/api/webclient/RuleProfile/Get",
      create: "/api/webclient/RuleProfile/Create",
      copy: "/api/webclient/RuleProfile/Copy",
      rename: "/api/webclient/RuleProfile/Rename",
      delete: "/api/webclient/RuleProfile/Delete",
      updateXmlSchema: "/api/webclient/RuleProfile/UpdateXmlSchema",
      getRules: "/api/webclient/RuleProfile/GetRules",
      getProfileRule: "/api/webclient/RuleProfile/GetProfileRules",
      updateProfileRules: "/api/webclient/RuleProfile/UpdateProfileRules",
      deleteProfileRules: "/api/webclient/RuleProfile/DeleteProfileRules"
    },
    mediaConverterProfile: {
      getProfiles: "/api/webclient/MediaConverterProfile/GetProfiles",
      getProfileParameters: "/api/webclient/MediaConverterProfile/GetProfileParameters",
      rename: "/api/webclient/MediaConverterProfile/RenameProfile",
      copy: "/api/webclient/MediaConverterProfile/CopyProfile",
      delete: "/api/webclient/MediaConverterProfile/DeleteProfile",
      update: "/api/webclient/MediaConverterProfile/UpdateProfile",
      getSmartSnippetsEntries: "/api/webclient/MediaConverterProfile/GetSmartSnippetsEntries"
    },
    artificialIntelligence: {
      providerConfiguration: {
        get: "/api/webclient/ArtificialIntelligence/GetProviderConfigurations",
        update: "/api/webclient/ArtificialIntelligence/SetProviderConfigurations"
      },
      promptConfiguration: {
        get: "/api/webclient/ArtificialIntelligence/GetPromptConfigurations",
        update: "/api/webclient/ArtificialIntelligence/SetPromptConfigurations"
      }
    }
  },
  import: {
    getAll: "/api/webclient/Import/GetImportProjects",
    getSourceStructure: "/api/webclient/Import/GetSourceStructure",
    getTargetStructure: "/api/webclient/Import/GetTargetStructure",
    save: "/api/webclient/Import/SaveImport",
    delete: "/api/webclient/Import/DeleteImport",
    copy: "/api/webclient/Import/CopyProject",
    source: {
      upload: "/api/webclient/Import/UploadSourceFile",
      delete: "/api/webclient/Import/DeleteSourceFile",
      get: "/api/webclient/Import/GetSourceStructure",
      save: "/api/webclient/Import/SaveSourceStructure",
      reload: "/api/webclient/Import/ReloadSourceFile",
      download: "/api/webclient/Import/DownloadSourceFile",
      filePreview: "/api/webclient/Import/GetSourceFilePreview"
    },
    mappings: {
      get: "/api/webclient/Import/GetMappings",
      save: "/api/webclient/Import/SaveMappings",
      delete: "/api/webclient/Import/DeleteMappings"
    },
    start: "/api/webclient/Import/Execute",
    cancel: "/api/webclient/Import/Cancel",
    getProgress: "/api/webclient/Import/GetProgress",
    getLog: "/api/webclient/Import/GetLog",
    getLastImport: "/api/webclient/Import/GetLastImport",
    getLastImportEnabledStatus: "/api/webclient/Import/GetLastImportEnabledStatus",
    getExternalSourceConnections: "/api/webclient/ExternalData/GetAllExternalDataConnections",
    getSourceStructureForExternalSourceImport: "/api/webclient/ExternalData/GetSourceStructureForImport"
  },
  translationManager: {
    projects: {
      valueCounts: "/api/webclient/TranslationProject/GetTranslationProjectValueCounts",
      create: "/api/webclient/TranslationProject/Create",
      get: "/api/webclient/TranslationProject/GetTranslationProjects",
      groupCounts: "/api/webclient/TranslationProject/GetTranslationCategoryCount",
      delete: "/api/webclient/TranslationProject/Delete",
      update: "/api/webclient/TranslationProject/Update",
      overviewValues: "/api/webclient/TranslationProject/GetOverview",
      export: "/api/webclient/TranslationProject/Export",
      import: "/api/webclient/TranslationProject/Import",
      download: "/api/webclient/TranslationProject/Download",
      publish: "/api/webclient/TranslationProject/PublishTranslationProject",
      hasOverlongTargetValues: "/api/webclient/TranslationProject/HasOverlongTargetValues"
    },
    translationEntries: {
      get: "/api/webclient/TranslationProject/GetTranslationEntries",
      update: "/api/webclient/TranslationProject/UpdateTranslationEntries",
      translateWithDeepL: "/api/webclient/TranslationProject/TranslateEntriesWithDeepL",
      getDetails: "/api/webclient/TranslationProject/GetTranslationDetails",
      updateDetails: "/api/webclient/TranslationProject/UpdateTranslationDetailsEntries"
    }
  },
  economicOperator: {
    getAll: "/api/webclient/EconomicOperator/GetAll",
    save: "/api/webclient/EconomicOperator/Save",
    delete: "/api/webclient/EconomicOperator/Delete",
    exportAll: "/api/webclient/EconomicOperator/ExportAll",
    import: "/api/webclient/EconomicOperator/Import",
    downloadExport: "/api/webclient/EconomicOperator/DownloadExport",
    attributes: {
      getAll: "/api/webclient/EconomicOperator/GetEconomicOperatorAttributes"
    }
  },
  gpsr: {
    getEconomicOperatorsAssignedToArticle: "/api/webclient/GPSR/GetEconomicOperatorsAssignedToArticle",
    getResolvedArticleLinkData: "/api/webclient/GPSR/GetResolvedArticleLinkData",
    assignEconomicOperatorsToArticle: "/api/webclient/GPSR/AssignEconomicOperatorsToArticle",
    getLinkDefinitions: "/api/webclient/GPSR/GetLinkDefinitions",
    getPossibleLinkDefinitions: "/api/webclient/GPSR/GetPossibleLinkDefinitions",
    saveLinkDefinitions: "/api/webclient/GPSR/SaveLinkDefinitions",
    deleteLinkDefinitions: "/api/webclient/GPSR/DeleteLinkDefinitions"
  },
  visualLink: {
    get: "/api/webclient/VisualLink/Get",
    save: "/api/webclient/VisualLink/Save",
    mediaAssetPreview: "/api/webclient/VisualLink/GetMediaAsset"
  },

  /*eslint-disable  @typescript-eslint/no-explicit-any*/
  format(url: string, params: Record<string, any>, keepUsedKeys = false) {
    const getMatch = function (x: string) {
      const reg = new RegExp("\\{(?<key>[^\\}]+)\\}", "ig");
      return reg.exec(x);
    };

    let match: RegExpExecArray | null;
    while ((match = getMatch(url))) {
      if (match && match.groups) {
        url = url.replace(match[0], params[match.groups.key] as string);
        if (!keepUsedKeys) delete params[match.groups.key];
      }
    }

    return url;
  }
};
